import { REPORTS_URL, RESTAURANT_REPORTS_URL } from '../../CONSTANTS'
import { SYSTEM_ERROR } from "../../config/CONSTANTS";
import axios from 'axios'
import Cookies from 'universal-cookie';

const urlParams = new URLSearchParams(window.location.search);
const cook = new Cookies().get('loginData1')
const authToken = urlParams.get("at");


const headersdata = {
    'content-type': 'application/json',
    'Accept': 'application/json',
    'Authorization': cook != undefined ? cook.accessToken : authToken ? authToken : ''
}

export const deficitReport = (data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(REPORTS_URL + "deficitReport", data, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemList axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const pendingPurchaseOrderByVendor = (data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(REPORTS_URL + "pendingPurchaseOrderByVendor", data, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemList axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};
export const pendingSalesOrderByCustomer = (data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(REPORTS_URL + "pendingSalesOrderByCustomer", data, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemList axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const customerPriceList = (data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(REPORTS_URL + "customerPriceList", data, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemList axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const vendorPriceList = (data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(REPORTS_URL + "vendorPriceList", data, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemList axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const SalesByCreditNotes = (data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(REPORTS_URL + "SalesByCreditNotes", data, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemList axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const consumptionVsCurrentStock = (data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(RESTAURANT_REPORTS_URL + "consumptionVsCurrentStock", data, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemList axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const HsnReport = (data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(REPORTS_URL + "hsnReport", data, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemList axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};
export const CreditHsnReport = (data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(REPORTS_URL + "CreditNotesHsnReport", data, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemList axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};


export const PalleteOccupacyReports = (data) => {
    return new Promise((resolve, reject) => {
        try {
            axios.post(REPORTS_URL + "getPalletOccupancy", data, { headers: headersdata })
                .then((res) => {
                    resolve(res.data)
                }).catch((err) => {
                    reject("Error in getItemList axios!", err);
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    })
}

export const getCustomerFssaiReports = () => {
    return new Promise((resolve, reject) => {
        try {
            axios.get(REPORTS_URL + "getAllCustomerFssaiDetail", { headers: headersdata })
                .then((res) => {
                    resolve(res.data)
                }).catch((err) => {
                    reject("Error in getAllCustomerFssaiDetail axios!", err);
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    })
}

export const getCustomerCategoryDiscountReport = () => {
    return new Promise((resolve, reject) => {
        try {
            axios.get(REPORTS_URL + "getCustomerCategoryDiscountReport", { headers: headersdata })
                .then((res) => {
                    resolve(res.data)
                }).catch((err) => {
                    reject("Error in getCustomerCategoryDiscountReport axios!", err);
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    })
}

export const getOrderVsDispatch = (data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                // .post(WAREHOUSEITEM_URL() + "getAllRecordsByWarehouseId", data, { headers: headersdata })
                .post(REPORTS_URL + "getOrderVsDispatchRecord", data, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getIssuanceRecords axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};
export const getCustomSales = (data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(REPORTS_URL + "getSalesCustomReport", data, {
                    headers: headersdata,
                })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemList axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const getMonthlySalesByCustomer = (data) => {
    return new Promise((resolve, reject) => {
        try {
            axios.post(REPORTS_URL + "getMonthlySalesByCustomer", data, {
                headers: headersdata,
            })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemList axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    })
}
export const getMonthlySoldItemsWithQuantity = (data) => {
    return new Promise((resolve, reject) => {
        try {
            axios.post(REPORTS_URL + "getMonthlySoldQuantitiesByItem", data, {
                headers: headersdata,
            })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemList axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    })
}